import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from 'primeng/datepicker';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';

@Component({
   selector: 'package-receive-shipper',
   templateUrl: './package.receive.shipper.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
   imports: [FormsModule, Toast, CommonModule, DatePickerModule, PackageReceiveProgressComponent, CardModule]
})
export class PackageReceiveShipperComponent implements OnInit {

   package: PackageReceiveService;
   minDateValue: Date;
   maxDateValue: Date = new Date();

   constructor(private packageReceiveSvc: PackageReceiveService,
      private messageService: MessageService,
      private router: Router) {
      this.package = packageReceiveSvc;
     this.package.stepnumber = 2;

   }

   ngOnInit() {
      if (!this.package.trackingNumber) {
         this.router.navigate(['package-receive-new/package-receive-scan']);
      }

      var d = new Date();
      d.setDate(d.getDate() - 3);
      this.minDateValue = d;
 
     if (this.package.ShipmentType) {
         this.radioChecked(this.package.ShipmentType, 0);
      }
   }

   nextPage() {
      if (this.canProceed()) {
         this.router.navigate(['package-receive-new/package-receive-client']);
      }
   }

   prevPage() {
      this.router.navigate(['package-receive-new/package-receive-scan']);
   }

   radioChecked(id, i) {
      this.package.shipmenttypes.forEach(item => {
         if (item.value !== id) {
            item.selected = false;
         } else {
           this.package.shipmentTypeDisplay = item.label;
           this.package.ShipmentType = item.value;
            item.selected = true;
         }
      })
   }

   canProceed(): boolean {
      if (!this.package.ShipmentType || !this.package.shipmentTypeDisplay) {
         this.messageService.add({ severity: 'error', summary: 'Shipment Type', detail: 'A shipment type must be selected!', life: 6000, closable: false, sticky: false });
         return false;
      }

      if (!this.package.DeliveredDate) {
         this.messageService.add({ severity: 'error', summary: 'Date/Time Delivered', detail: 'A delivered date & time must be provided!', life: 6000, closable: false, sticky: false });
         return false;
      }

      return true;
   }
}
